import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button, Input, Anchor, message, Popover, Collapse, Carousel, Dropdown, Statistic, Modal } from "antd";
import { DotLoader } from 'react-spinners';
import CountUp from 'react-countup';
import {
  RightOutlined,
  PlusOutlined
} from "@ant-design/icons";
import "animate.css";
import WOW from "wow.js";
import nodata from "@/assets/images/nodata.png";

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { useAppKitAccount, useAppKit, useAppKitNetwork, useWalletInfo } from "@reown/appkit/react";
import { base } from '@reown/appkit/networks'
import { tokenAbi, LOCKLPABI, LOCKDEAIABI } from "@/web3/ido.js";
import { useAccount, useSignMessage, useDisconnect, useReadContract, useBalance, useWriteContract, useWaitForTransactionReceipt, useSwitchChain, useBlockNumber, useSendTransaction, useGasPrice } from 'wagmi'
import { parseEther, parseUnits, parseGwei, formatEther } from 'viem';
import { useQueryClient } from '@tanstack/react-query'
import dayjs from "dayjs";
const { Link } = Anchor;
const Index = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [redeemId, setRedeemId] = useState(0);
  const LOCKED_LP_CONTRACT_ADDRESS = import.meta.env.VITE_LOCKED_CONTRACT_ADDRESS;
  const LP_CONTRACT_ADDRESS = import.meta.env.VITE_LP_CONTRACT_ADDRESS;
  const DEAI_CONTRACT_ADDRESS = import.meta.env.VITE_NEW_DEAI_CONTRACT_ADDRESS;
  const LOCKED_DEAI_CONTRACT_ADDRESS = import.meta.env.VITE_LOCKED_NEW_DEAI_CONTRACT_ADDRESS;
  const chainIdOwn = Number(import.meta.env.VITE_CHAIN_ID)
  const { open, close } = useAppKit()
  const { caipNetwork, caipNetworkId, chainId, switchNetwork } = useAppKitNetwork()
  const { address, isConnected, caipAddress, status } = useAppKitAccount()
  const queryClient = useQueryClient()
  const { data: blockNumber } = useBlockNumber({ watch: true })
  const { writeContract, error, data: writeData, success } = useWriteContract();
  const isApprovedString = useRef(0);

  const result = useWaitForTransactionReceipt({
    hash: writeData,
    chainId: chainIdOwn,
    confirmations: 1,
  })
  const [loading, setLoading] = useState(false)
  const { data: lockDeaiConfigs, queryKey: queryKey5 } = useReadContract({
    address: LOCKED_LP_CONTRACT_ADDRESS,
    abi: LOCKLPABI,
    functionName: 'getLockedDatas',
    chainId: chainIdOwn,
    args: [address],
  })

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: queryKey5 })
  }, [blockNumber, queryClient])
  useEffect(() => {
    console.log("lockDeaiConfigs", lockDeaiConfigs)
    if (lockDeaiConfigs && lockDeaiConfigs.length > 0) {
      getList()
    }
  }, [lockDeaiConfigs])
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (error) {
        setLoading(false)
        let str = JSON.parse(JSON.stringify(error).replace(/\n/g, ""));
        message.warning(str.shortMessage);
      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [error]);
  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (result?.status === "success") {
        message.success(t("Success"))
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
      if (result?.status === "error") {
        message.error(t("error"));
        setLoading(false)

      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [result]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (chainId) {
        if (chainId != Number(chainIdOwn)) {
          switchNetwork(base)
        }
      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [chainId]);
  const getList = () => {
    let arr = [];
    console.log(dayjs().unix())
    lockDeaiConfigs.forEach((item) => {
      arr.push({
        ...item,
        startDate: dayjs(Number(item.startTime) * 1000).format("YYYY-MM-DD HH:mm:ss"), // 格式化时间戳
        endDate: dayjs(Number(item.endTime) * 1000).format("YYYY-MM-DD HH:mm:ss"), // 格式化时间戳
        day: Math.floor((Number(item.endTime) - Number(item.startTime)) / (24 * 3600)), // 计算天数
        isExpired: Number(item.endTime) < dayjs().unix(), // 判断是否到期,到期为true
        amountNum: formatEther(item.amount),
      })
    })
    console.log(arr)
    setDataList(arr)
  }
  const saveNumberTwo = (num) => {
    if (num * 1 === 0) return 0;
    let arr = (num + "").split(".");
    if (arr.length === 2) {
      let new_num = arr[0] + "." + arr[1].substring(0, 2);
      return new_num === "0.00" ? "0" : new_num;
    } else {
      return num + ".00";
    }
  }
  const tapredeem = (item) => {
    setRedeemId(item.id);
    setLoading(true)
    writeContract({
      address: LOCKED_LP_CONTRACT_ADDRESS,
      abi: LOCKLPABI,
      functionName: "userUnlock",
      chainId: chainIdOwn,
      args: [item.id]
    })
  }
  const tapSure = () => {
    setLoading(true)
    writeContract({
      address: LOCKED_DEAI_CONTRACT_ADDRESS,
      abi: LOCKDEAIABI,
      functionName: "userAdvanceUnlockDeai",
      chainId: chainIdOwn,
      args: [redeemId]
    })
  }
  return (
    <div className="history_box_lp">
      <div className="table">
        <div className="thead">
          <div className="td">{t("Number of locked")}(LP)</div>
          <div className="td">{t("Lock up period")}</div>
          <div className="td">{t("Daily Return")}</div>
          <div className="td">{t("Locking time")}</div>
          <div className="td">{t("Expiration date")}</div>
          <div className="td">{t("operate")}</div>
        </div>
        {
          dataList.map((item, index) => {
            return (<div className="tbody" key={index}>
              <div className="td">{item.amountNum}</div>
              <div className="td">{item.day} {t("day")}</div>
              <div className="td">{Number(item.coefficient) / 100}</div>
              <div className="td">{item.startDate}</div>
              <div className="td">{item.endDate}</div>
              <div className="td">
                {item.isTaked ? '已赎回' : item.isExpired ? <Button type="primary" loading={loading && item.id === redeemId} onClick={() => tapredeem(item)}>{t("redeem")}</Button> : "不可赎回"}
              </div>
            </div>)
          })
        }
      </div>
      <div className="m_table">
        {
          dataList.map((item, index) => {
            return (<div className="list" key={index}>
              <div className="flex">
                <div>{t("Number of locked")}(LP)</div>
                <div>{item.amountNum}</div>
              </div>
              <div className="flex">
                <div>{t("Lock up period")}</div>
                <div>{item.day} {t("day")}</div>
              </div>
              <div className="flex">
                <div>{t("Daily Return")}</div>
                <div>{Number(item.multiple) / 10000}</div>
              </div>
              <div className="flex">
                <div>{t("Locking time")}</div>
                <div>{item.startDate}</div>
              </div>
              <div className="flex">
                <div>{t("Expiration date")}</div>
                <div>{item.endDate}</div>
              </div>
              <div className="flex">
                <div>{t("operate")}</div>

                <div>
                  {item.isTaked ? '已赎回' : item.isExpired ? <Button type="primary" loading={loading && item.id === redeemId} onClick={() => tapredeem(item)}>{t("redeem")}</Button> : "不可赎回"}
                </div>
              </div>
            </div>)
          })
        }
      </div>
       <div className="nodata" style={{display:dataList.length > 0 ? "none" : "flex"}}>
              <img src={nodata} alt="" />
            </div>
      <Modal title="" centered open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null}>
        <div className="modal_box">
          <div style={{ lineHeight: "30px" }}>{t("Note: 20% penalty will be deducted for early redemption of locked tokens. Deai tokens will be submitted to DAO Treasury Foundation for community marketing purposes (points earned before redemption will not be affected)")}</div>
          <div className="btn_box">
            <Button type="primary" className="btn" loading={loading} onClick={tapSure}>{t("Early Redemption")}</Button>
          </div>
        </div>
      </Modal>
    </div >
  );
};
export default Index;
